__turbopack_context__.v({
  "blankLine": "product-overview-module__GZpsWa__blankLine",
  "blankLine1": "product-overview-module__GZpsWa__blankLine1",
  "cardGrid": "product-overview-module__GZpsWa__cardGrid",
  "content": "product-overview-module__GZpsWa__content",
  "loremIpsum": "product-overview-module__GZpsWa__loremIpsum",
  "loremIpsum1": "product-overview-module__GZpsWa__loremIpsum1",
  "loremIpsumDolor": "product-overview-module__GZpsWa__loremIpsumDolor",
  "loremIpsumDolorContainer": "product-overview-module__GZpsWa__loremIpsumDolorContainer",
  "loremIpusm": "product-overview-module__GZpsWa__loremIpusm",
  "loremIpusmLoremIpsumLorem": "product-overview-module__GZpsWa__loremIpusmLoremIpsumLorem",
  "noGap": "product-overview-module__GZpsWa__noGap",
  "overview": "product-overview-module__GZpsWa__overview",
  "root": "product-overview-module__GZpsWa__root",
  "variusDignissimRisus": "product-overview-module__GZpsWa__variusDignissimRisus",
  "vestibulumTristiqueEget": "product-overview-module__GZpsWa__vestibulumTristiqueEget",
});
